import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import AdvanceCustomerBalanceFilters from "./components/AdvanceCustomerBalanceFilters";
import AdvanceCustomerBalanceTable from "./components/AdvanceCustomerBalanceTable";
import { fetchAdvanceCustomerBalance } from "./AdvanceCustomerBalanceThunk";
import ReportDom from "../../components/common/ReportDom";
import { exportAdvanceCustomerBalanceCsv } from "./components/exportAdvanceCustomerBalanceCsv";

const { Title } = Typography;

const AdvanceCustomerBalanceReport = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { filters, list } = useSelector((state) => state.advanceCustomerBalance);
  const { useBreakpoint } = Grid;
  const screens   = useBreakpoint();
  useEffect(() => {
    dispatch(fetchAdvanceCustomerBalance({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Advance Customer Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportAdvanceCustomerBalanceCsv({
      list,
      title:    "Advance Debtor / Customer Balance Report",
      filename: "advance_customer_balance",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }}>
              Advance Debtor / Customer Balance Report
            </Title>
          }
            extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <AdvanceCustomerBalanceFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <AdvanceCustomerBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Advance Customer Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <AdvanceCustomerBalanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default AdvanceCustomerBalanceReport;
